// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2H74Z","Label":"Input_Label__1hCvb","InputElement":"Input_InputElement__3L6j1","Invalid":"Input_Invalid__1-NNw"};